import React from 'react'
import { ImageBlock } from './image-block'
import { Chip } from './chip'
import { Avatar, AvatarGroup } from '@mui/material';

const NOOP = (item, index) => {}

export function NameBar({ id, name, image, color, backgroundColor, onClick = NOOP, index }): JSX.Element {
  const clickHandler = () => {
    onClick({ id, name, image, color, backgroundColor }, index)
  }
  return (
    <Chip
      onClick={clickHandler}
      label={name}
      avatar={<ImageBlock image={image} backgroundColor={backgroundColor} />}
      sx={{ color, backgroundColor, width: '100%' }}
    />
  )
}

export function NameBarStack({ collection = [], onClick = NOOP }) {
  if (!collection.length) {
    return null
  }
  return (
    <>
      {collection.map((item, index) => (
        <NameBar key={item.id} {...item} onClick={onClick} index={index}  />
      ))}
    </>
  )
}

export function AvatarStack({ collection = [], max = 5, width = 70, height = 70, onClick = NOOP }) {
  if (!collection.length) {
    return null
  }
  return (
    <AvatarGroup max={max} sx={{
      flexDirection: 'row',
    }}>
      {collection.map((item, index) => (
        <Avatar key={item?.id} alt={item?.name} title={item?.name} src={item?.image} sx={{ width, height }} onClick={() => onClick(item, index)} />
      ))}
    </AvatarGroup>
  )
}

export function MultiRowStack({ collection, max = 30, rows = 5, columns = 6 }) {
  const prefills = Array(rows).fill(columns)

  return (
    <>
      {prefills?.map((amount, index) => (
        <AvatarStack
          key={index}
          collection={collection?.slice(index * amount, (index + 1) * amount)}
          max={max}
        />
      ))}
    </>
  )
}